import { render, staticRenderFns } from "./ActivateAccount.vue?vue&type=template&id=47f1f39c&scoped=true&"
import script from "./ActivateAccount.vue?vue&type=script&lang=js&"
export * from "./ActivateAccount.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/login.css?vue&type=style&index=0&id=47f1f39c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f1f39c",
  null
  
)

export default component.exports